
  export default class XHR {
    constructor() {
      this.req = new XMLHttpRequest();
      this.req.onload = (e) => {
        if(4 === this.req.readyState && 200 === this.req.status){
          if('function' === typeof this.callback){
            this.callback(e);
          }
        }else{
          this.error(e);
        }
      };
      this.req.ontimeout =(e)=>{
        this.error(e);

      };
      this.req.onerror = (e) =>{
        this.error(e);
      };
      this.req.timeout = 10000;
    }
    error(e){
      console.warn(e)
      this.callback(false)
    }
    get(url, type, callback, cash){
      this.cnt=0;
      this.url=url;
      this.callback=callback;
      this.req.open('get', this.url + (cash?('?' + new Date().getTime()):''), !0);
      this.req.responseType=type;
      this.req.send(null);
    }
  }
